// src/utils/context/get-context-install-id/get-context-install-id.ts
function getContextInstallId() {
  let installationId = void 0;
  if (window.yvaDatastore?.contexts && window.yvaDatastore?.currentContextId) {
    installationId = window.yvaDatastore.contexts[window.yvaDatastore.currentContextId].data.device.installation_id;
  }
  return installationId;
}

export {
  getContextInstallId
};
